import React from 'react';
import { Button } from '@/components/ui/button';

function itemBorderClass(triggerType, clicked) {
  if (clicked) return 'opacity-50';
  if (triggerType === 'reply_received') return 'border-l-2 border-l-[#00C2C2] pl-3';
  return '';
}

export default function ChatTriggerNudgesMessage({ message, onChipClick, disabled, showChips = true }) {
  const intro = message?.text || '';
  const items = Array.isArray(message?.triggerItems) ? message.triggerItems : [];

  return (
    <div className="space-y-4">
      {intro ? <p className="text-sm text-[#0A1A2F] mb-0">{intro}</p> : null}
      {items.map((item, index) => {
        const key = item.id || `${item.accountName}-${index}`;
        const clicked = Boolean(item.clicked);
        return (
          <div
            key={key}
            className={`${index > 0 ? 'pt-4 border-t border-gray-200/80' : ''} ${itemBorderClass(item.triggerType, clicked)}`}
          >
            <p className="text-sm text-[#0A1A2F] leading-relaxed mb-2">
              {item.accountName ? (
                <>
                  <strong>{item.accountName}</strong>
                  {item.sentence ? ' — ' : ''}
                </>
              ) : null}
              {item.sentence}
            </p>
            {showChips && item.chipLabel ? (
              <Button
                type="button"
                variant="outline"
                className="w-full h-auto min-h-9 py-2 px-3 text-sm text-left whitespace-normal justify-start border-gray-300 hover:bg-white hover:border-[#00C2C2] text-[#0A1A2F] disabled:opacity-60"
                disabled={disabled || clicked}
                onClick={() => onChipClick?.(item, message)}
              >
                {item.chipLabel}
              </Button>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
